module.exports = __webpack_public_path__ + "static/img/Tallyn_Da_Silva.653e508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Tallyn_Da_Silva.jpg
// module id = 3flW
// module chunks = 0